module.exports = __webpack_public_path__ + "static/media/CSS3.24917e56.png";